import { vuexTypes } from '@/vuex/types'
import config from '@/config'
import { ErrorTracker } from '@/js/helpers/error-tracker'

export const sessionStoragePlugin = store => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case vuexTypes.CLEAR_STATE: {
        localStorage.removeItem(config.STORAGE_KEY)
        ErrorTracker.setLoggedInUser({})
        break
      }
      case vuexTypes.POP_STATE: {
        let savedStore = localStorage.getItem(config.STORAGE_KEY)

        if (!savedStore) {
          break
        }

        savedStore = JSON.parse(savedStore)

        store.replaceState({
          ...state,
          token: savedStore.token,
          authToken: savedStore.authToken,
          tokenAttrs: savedStore.tokenAttrs,
          account: savedStore.account,
          myRoleInfo: savedStore.myRoleInfo,
          accountAddress: savedStore.accountAddress,
          accountId: savedStore.accountId,
          logoutTime: savedStore.logoutTime,
        })

        break
      }
      default:
        localStorage.setItem(config.STORAGE_KEY, JSON.stringify({
          token: state.token,
          authToken: state.authToken,
          tokenAttrs: state.tokenAttrs,
          account: state.account,
          myRoleInfo: state.myRoleInfo,
          accountAddress: state.accountAddress,
          accountId: state.accountId,
          logoutTime: state.logoutTime,
        }))
    }
  })
}
